import { isBrowser } from '@publicss/utils';
import { useQuery } from 'react-query';

type IpapiData = {
  marketCity: string | null;
  city: string | null;
  geoData: {
    ip: string;
    city: string;
    region: string;
    country: string;
    latitude: number;
    longitude: number;
    zip: string;
  };
};

type IpapiResponse = {
  message: 'ok';
} & IpapiData;

type IpapiError = {
  message: string;
};

export function useIpapi() {
  if (!isBrowser()) return;

  const { data } = useQuery<IpapiResponse, IpapiError>({
    queryKey: ['ipapi'],
    queryFn: () =>
      fetch('/api/ipapi').then((res) => res.json()) as Promise<IpapiResponse>,
    // TODO: remove after testing
    enabled: window.location.pathname.includes('test-variant'),
  });

  return data;
}
